import React, { useContext } from "react";
import Barcode from "react-barcode";
import "../../CSS/Invoice.css";
import AuthUser from "../AuthUser";
import moment from "moment";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";
import { appContext } from "../../navbar/auth";

const Invoice = ({
  specialDiscount,
  invoice,
  delivery_charge,
  invoiceData,
}) => {
  const { user } = AuthUser();
  const { allSubTotalWithoutDiscount, stickerCart, paidAmount } =
    useContext(appContext);
  const lan = useLanguage(cashierLang);

  console.log(invoiceData, "cart");
  return (
    <div
      style={{ paddingLeft: "35px", paddingRight: "35px" }}
      className="invoice-print"
    >
      <div className="invoice-pharmacy-details d-flex align-items-center">
        <img
          src={user?.organization?.logo}
          className="img-fluid"
          style={{ height: "80px" }}
          alt=""
        />
        <div className="text-center flex-grow-1">
          <div style={{ marginLeft: "-80px" }}>
            <h5>{user?.organization?.name}</h5>
            <p>Location : {user?.organization?.address}</p>
            <p>Tel : {user?.organization?.mobile}</p>
            <h6 className="mt-2">{lan?.invoice}</h6>
          </div>
        </div>
      </div>

      <div className="invoice-date invoice-border-dashed">
        {/* <p style={{textAlign:'center'}}>Invoice No : {invoice} </p>
                <p style={{textAlign:'center'}}>Sales Person : Dummy </p> */}

        <div className="d-flex justify-content-between">
          <div>
            <p>
              {lan?.name} : {invoiceData?.name}{" "}
            </p>
            <p>
              {lan?.address} : {invoiceData?.address}{" "}
            </p>
            <p>
              {lan?.mobile} : {invoiceData?.mobile}{" "}
            </p>
          </div>
          <div>
            <p style={{ textAlign: "end" }}>
              {lan?.invoiceNo} : {invoice}{" "}
            </p>
            <p style={{ textAlign: "end" }}>
              {lan?.invoice} {lan?.date} :{" "}
              {moment(invoiceData?.date).format("DD-MM-YYYY")}{" "}
            </p>
            <p style={{ textAlign: "end" }}>
              {lan?.printDateTime} : {moment().format("DD-MM-YYYY hh:mm A")}{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="invoice-item-table">
        <table>
          <tr className="invoice-border-dashed">
            <td width={"45%"}>{lan?.item}</td>
            <td width={"15%"} className="text-right">
              {lan?.quantity}
            </td>
            <td width={"15%"} className="text-right">
              {lan?.unit}
            </td>
            <td width={"10%"} className="text-right">
              {lan?.price}
            </td>
            <td width={"15%"} className="text-end">
              {lan?.totalPrice}
            </td>
          </tr>
          {stickerCart
            .filter((c) => parseInt(c.pcs) > 0)
            .map((item, i) => (
              <tr key={i}>
                <td width={"45%"}>{item.name}</td>
                <td width={"15%"} className="text-start">
                  {item?.pcs}
                </td>
                <td width={"15%"} className="text-start">
                  {item?.drug?.unit}
                </td>
                <td width={"10%"} className="text-start">
                  {item?.price}
                </td>
                <td width={"15%"} className="text-end">
                  {Number(item.totalPrice)?.toFixed(2)}
                </td>
              </tr>
            ))}
          <tr className="invoice-border-dashed-top">
            <td colSpan={4} className="text-end fw-bolder">
              {lan?.subTotal} :{" "}
            </td>
            <td className="text-end">
              {(
                parseFloat(allSubTotalWithoutDiscount) -
                parseFloat(delivery_charge || 0)
              )?.toFixed(2)}{" "}
            </td>
          </tr>

          {/* <tr>
            <td colSpan={4} className="text-end">
              {lan?.vatTax} :{" "}
            </td>
            <td className="text-end">0</td>
          </tr> */}
          <tr>
            <td colSpan={4} className="text-end">
              Delivery Charge :{" "}
            </td>
            <td className="text-end">
              {parseFloat(delivery_charge || 0)?.toFixed(2)}
            </td>
          </tr>
          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr>
              <td colSpan={4} className="text-end">
                {lan?.specialDiscount} :{" "}
              </td>
              <td className="text-end">{specialDiscount}</td>
            </tr>
          )}

          <tr className="invoice-border-dashed-top">
            <td colSpan={4} className="text-end fw-bolder">
              {lan?.grandTotal} :{" "}
            </td>

            <td className="text-end">
              {(allSubTotalWithoutDiscount - specialDiscount)?.toFixed(2)}{" "}
            </td>
          </tr>
          <tr className="invoice-border-dashed-top mt-3">
            <td colSpan={3} className="text-end fw-bolder">
              Last Due :{" "}
            </td>
            <td>{invoiceData?.last_due_date}</td>
            <td className="text-end">{invoiceData?.last_due}</td>
          </tr>
          <tr className="invoice-border-dashed-top mt-3"></tr>
          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr>
              <td colSpan={4} className="text-end fw-bolder">
                {lan?.paidAmount} :{" "}
              </td>
              <td className="text-end">{paidAmount} </td>
            </tr>
          )}

          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr className="invoice-border-dashed">
              <td colSpan={4} className="text-end fw-bolder">
                Present Due :{" "}
              </td>

              <td className="text-end">
                {parseFloat(paidAmount) > 0
                  ? (
                      parseFloat(invoiceData?.due || 0) +
                        parseFloat(allSubTotalWithoutDiscount || 0) -
                        parseFloat(paidAmount || 0) -
                        specialDiscount || 0
                    ).toFixed(2)
                  : (
                      parseFloat(invoiceData?.due || 0) +
                        parseFloat(allSubTotalWithoutDiscount || 0) -
                        specialDiscount || 0
                    ).toFixed(2)}
              </td>
            </tr>
          )}
        </table>
      </div>
      <div className=" invoice-creator mt-1">
        <p>
          {lan?.providedBy}: {user?.name}
        </p>
      </div>
      {/* <div className="branding-section mt-3 mx-auto text-center mx-auto">
        <p>{lan?.technologyPartner} Zaimah Technologies Ltd.</p>
      </div>

      <div className="invoice-greeting d-flex justify-content-center align-items-center mt-1">
        <Barcode displayValue={false} height={40} width={3} value={invoice} />
      </div> */}
      <div className="d-flex justify-content-center branding-section mt-5">
        <p>{lan?.thankYou}</p>
      </div>
    </div>
  );
};

export default Invoice;
